module.exports = __webpack_public_path__ + "96939e90f7ce2488e0cfda6ad7a85b46.png";